var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFlowRunners = function SvgFlowRunners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.163 8.663a2.34 2.34 0 0 1 2.331 2.177l.006.16v7.163a2.34 2.34 0 0 1-2.177 2.331l-.16.006H11a2.34 2.34 0 0 1-2.332-2.177l-.005-.16V11a2.34 2.34 0 0 1 2.177-2.332l.16-.005h7.163zm0 1.093H11c-.644 0-1.173.49-1.237 1.117L9.756 11v7.163c0 .643.49 1.173 1.117 1.237l.127.007h7.163A1.246 1.246 0 0 0 19.4 18.29l.007-.127V11a1.246 1.246 0 0 0-1.244-1.244zM12.79 5.081a2.34 2.34 0 0 1 2.331 2.178l.006.16-.099.099h-.895l-.1-.1c0-.643-.49-1.173-1.116-1.237l-.127-.006H7.419c-.644 0-1.174.49-1.238 1.117l-.006.127v5.372c0 .643.49 1.173 1.117 1.237l.127.007.099.099v.895l-.1.099a2.34 2.34 0 0 1-2.331-2.177l-.006-.16V7.419A2.34 2.34 0 0 1 7.26 5.087l.16-.006h5.372zM7.419 1.5A2.34 2.34 0 0 1 9.75 3.677l.006.16-.099.1h-.895l-.1-.1c0-.643-.49-1.173-1.116-1.237l-.127-.007H3.837A1.246 1.246 0 0 0 2.6 3.71l-.007.127V7.42c.001.643.49 1.173 1.117 1.237l.127.007.1.099v.895l-.1.099A2.34 2.34 0 0 1 1.506 7.58L1.5 7.42V3.837a2.34 2.34 0 0 1 2.177-2.331l.16-.006H7.42z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgFlowRunners;